<aside class="sidebar">
  <header class="shadow-sm">
    <h4 [translate]="Localization.InterventionTeams"
        class="title"></h4>
    <i class="fa fa-search"></i>
    <input
      [(ngModel)]="searchPhrase"
      class="form-control"
      type="search"/>
    <a (click)="addTeam()"
       class="btn-floating"
       role="button">
      <i class="fa fa-plus"></i>
    </a>
  </header>

  <section class="teams">
    <ol class="scroll-view team-list"
        #teamList
        *ngIf="!activity.isBusyWith(InterventionTeamManagerActivity.LoadTeams); else loadingView">
      <li *ngFor="let team of filteredTeams"
          [routerLink]="'./'+team.id"
          routerLinkActive="active">
        {{ team.label }}
      </li>
    </ol>
  </section>
</aside>
<main class="content">
  <div class="scroll-view">
    <router-outlet></router-outlet>
  </div>
</main>

<ng-template #loadingView>
  <mdb-spinner spinnerType="big"
               spinnerColor="blue"></mdb-spinner>
</ng-template>
